import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ProductCardCarousel, ProductTransformerV2 } from '@mafc/common';
import { useFeature } from '@mafc/appshell';
import { cartReponseShaper } from 'pages/NewCart/redux/actions/cartAction.helper';
import { updateCart } from 'pages/NewCart/redux/actions/fetchCart.actions';
import { getEarnedPoints } from 'pages/Cart/redux/actions';
import * as Styled from './AdtechCartCarousel.styles';
import { GROWTHBOOK_FLAGS } from 'pages/NewCart/constants/growthbook.constants';
import ICartResponse from 'network/response/ICart';

const MINI_LENGTH = 7;
const MAX_LENGTH = 20;
const AdtechCartCarousel = React.memo(() => {
  const adtechPlacemetConfig = useFeature(GROWTHBOOK_FLAGS.ADTECH_CAROUSEL_CONFIG).value || [];
  const dispatch = useDispatch();
  const placementId = (adtechPlacemetConfig[0] && adtechPlacemetConfig[0].placement_id) || '';
  const onSuccessCb = useCallback(
    (data: { cart: ICartResponse }) => {
      const transformedCart = cartReponseShaper(data.cart);
      dispatch(getEarnedPoints());
      updateCart(dispatch, transformedCart);
    },
    [dispatch]
  );

  const products = useSelector((state: { adtech: { criteoCarousels: any } }) => {
    return (state.adtech.criteoCarousels[placementId] || []).slice(0, MAX_LENGTH);
  });
  const carouselHeader = useSelector((state: { adtech: { criteoCarouselsHeader: any } }) => {
    return state.adtech.criteoCarouselsHeader[placementId] || '';
  });

  const productCards = new ProductTransformerV2(products).getProductCards(
    undefined,
    `${carouselHeader.toLowerCase()}|${placementId}`
  );

  return productCards.length > MINI_LENGTH ? (
    <ProductCardCarousel
      listName={`${placementId}|${carouselHeader.toLowerCase()}`}
      gaListName={`${placementId}|${carouselHeader.toLowerCase()}`}
      JSXTitle={<Styled.SponsoredProductsTitle>{carouselHeader}</Styled.SponsoredProductsTitle>}
      products={[...productCards]}
      isSponsoredListing
      variant="regular"
      onSuccessCb={onSuccessCb}
      isCart={true}
    />
  ) : null;
});

export default AdtechCartCarousel;
